<script>
  /**
   * 単一選択可能なドロップダウン式 選択入力欄
   */
  export let id
  export let name
  export let label
  export let options
  export let required = undefined
  export let value = undefined
</script>

<div class="field">
  <label for={id} class="label">{label}</label>
  <div class="control">
    <div class="select">
      <select {id} {name} {required} data-testid={`${id}-select`} bind:value>
        <option disabled selected value data-testid={`${id}-option0`} />
        {#if options}
          {#each options as option, index}
            <option data-testid={`${id}-option${index + 1}`}>{option}</option>
          {/each}
        {/if}
      </select>
    </div>

    <!-- 選択解除ボタン -->
    {#if value}
      <button
        type="button"
        class="delete"
        data-testid={`${id}DeselectButton`}
        aria-label="close"
        on:click={() => (value = '')}
      />
    {/if}
  </div>
</div>

<style>
  .control {
    display: flex;
  }

  button.delete {
    margin: 10px;
  }
</style>
